

import {TweenMax, TimelineMax, Linear, Cubic, Sine} from 'gsap';
import 'gsap/ScrollToPlugin';
//import 'gsap/BezierPlugin';
import preventScroll from 'prevent-scroll';


import Hammer from 'hammerjs';

// INIT
((root) => {

    const Snap = require('imports-loader?this=>window,fix=>module.exports=0!snapsvg/dist/snap.svg.js');

    const dataUtils = require('./rrjs/utils/data.js');
    const svgUtils = require('./rrjs/utils/DrawSVGUtils.js');
    const LoadHTMLCommand = require('./rrjs/base/commands/load/axios/AxiosLoadHTMLCommand.js');
    const LoadMediaCommand = require('./rrjs/base/commands/load/LoadMediaCommand.js');
    const AbstractMediaStorage = require('./rrjs/base/commands/load/assist/AbstractMediaStorage.js');
    const AbstractCommand = require('./rrjs/base/commands/AbstractCommand.js');
    const AsyncCommand = require('./rrjs/base/commands/AsyncCommand.js');
    const MacroCommand = require('./rrjs/base/commands/MacroCommand.js');
    const CustomEase = require('../vendors/gsap/easing/CustomEase.js');


    // Include svgUtils methods
    root.svg = {};
    svgUtils.mixin(root.svg);


    // I. Model:

    // 1. DOM storage and opportunity to display page state
        root.domStateStore = ((stateStoreSelector) => {
            function Store() {
                this.stateStore = document.querySelector(stateStoreSelector);

                this.getState = (key) => {
                    return dataUtils.getData(this.stateStore, key);
                };

                this.setState = (key, value, write) => {
                    return dataUtils.setData(this.stateStore, key, value, write);
                };
            }
            return new Store();
        })('body');

        // Show preloader / just in case : it should be set by default in the initial html code
        root.domStateStore.setState('loaderEnabled', 'enabled', true);
        root.domStateStore.setState('loading', 'initial', true);






    //
    /* touch move on teasers */

    const uiTouch = {
        scrollElem: document.querySelector('.teasers__wrap'),
        hammer: new Hammer(document.querySelector('.teasers__wrap')),
        init: function() {

            const bodyHalf = document.body.clientWidth / 2;

            const scrollElem = this.scrollElem;

            const scrollElemWidth = document.querySelector('.teasers__ui').offsetWidth;
            scrollElem.style.transform = `translateX(${scrollElemWidth / 2 * -1}px)`;

            this.hammer.on('pan', (e) => {
                function getTranslateX() {
                    const style = window.getComputedStyle(scrollElem);
                    const matrix = new WebKitCSSMatrix(style.webkitTransform);
                    return matrix.m41;
                }
                const currentValue = getTranslateX();

                let deltaValue = e.deltaX < 0 ? e.deltaX * -1 : e.deltaX;
                deltaValue = deltaValue * 100 / scrollElemWidth;

                let newValue = e.deltaX < 0 ? currentValue - deltaValue : currentValue + deltaValue;

                newValue = newValue > bodyHalf * -1 ? bodyHalf * -1 : newValue;
                newValue = newValue < (scrollElemWidth - bodyHalf) * -1 ? (scrollElemWidth - bodyHalf) * -1 : newValue;

                scrollElem.style.transform = `translateX(${newValue}px)`;
                uiEvents.pause();
            });

            this.hammer.on('panend', () => {
                uiEvents.unpause();
            });

            this.hammer.get('pan').set({enable: false});
        },
        start: function() {
            this.hammer.get('pan').set({enable: true});
        },
        pause: function() {
            this.hammer.get('pan').set({enable: false});
        }
    }

    const uiEvents = (() => {
        function UIClass() {
            this.isTouch = 'ontouchstart' in window || navigator.maxTouchPoints;
            this.clickElements = [...document.querySelectorAll('.js-ui [data-route-id]')];
            this.clickCounts = [0,0,0,0,0];
        }

        const p = UIClass.prototype;

        // Add Event Dispatcher methods
        createjs.EventDispatcher.initialize(p);

        p.init = function() {
            this.clickElements.forEach((teaser, teaserIndex) => {

                if (this.isTouch) {
                    teaser.addEventListener('click', (evt) => {
                        if (!this._started || !this._unpaused) return;
                        this.clickCounts.forEach((item, countIndex) => {
                            if (teaserIndex === countIndex) {
                                this.clickCounts[countIndex]++;
                            } else {
                                if (this.clickCounts[countIndex] > 0)
                                {
                                    let event = new createjs.Event('outTeaser');
                                    event.targetElement = this.clickElements[countIndex];
                                    this.dispatchEvent(event);
                                }
                                this.clickCounts[countIndex] = 0;
                            }
                        });

                        if (this.clickCounts[teaserIndex] === 1) {
                            let event = new createjs.Event('overTeaser');
                            event.targetElement = evt.currentTarget || evt.target;
                            this.dispatchEvent(event);
                        }

                        if (this.clickCounts[teaserIndex] >= 2) {
                            let event = new createjs.Event('clickTeaser');
                            event.targetElement = evt.currentTarget || evt.target;
                            this.dispatchEvent(event)
                        }
                    });
                } else {
                    teaser.addEventListener('mouseover', (evt) => {
                        if (!this._started || !this._unpaused) return;
                        let event = new createjs.Event('overTeaser');
                        event.targetElement = evt.currentTarget || evt.target;
                        this.dispatchEvent(event);
                    });
                    teaser.addEventListener('mouseout', (evt) => {
                        if (!this._started || !this._unpaused) return;
                        let event = new createjs.Event('outTeaser');
                        event.targetElement = evt.currentTarget || evt.target;
                        this.dispatchEvent(event);
                    });
                    teaser.addEventListener('click', (evt) => {
                        if (!this._started || !this._unpaused) return;
                        let event = new createjs.Event('clickTeaser');
                        event.targetElement = evt.currentTarget || evt.target;
                        this.dispatchEvent(event)
                    });
                }
            });
        };

        p.start = function () {
            this._started = true;
            this._unpaused = true;
        }

        p.unpause = function () {
            this._unpaused = true;
        }

        p.pause = function (forse) {
            this._unpaused = false;
            if (!forse) return;
            this._started = false;
            this.clickCounts.forEach((item, countIndex) => {
                if (this.clickCounts[countIndex] > 0)
                {
                    let event = new createjs.Event('outTeaser');
                    event.target = this.clickElements[countIndex];
                    this.dispatchEvent(event);
                }
                this.clickCounts[countIndex] = 0;
            });
        }


        return new UIClass();
    })();

    const mfxUpdater = {
        isTouch: 'ontouchstart' in window || navigator.maxTouchPoints,
        element: document.querySelector('.js-mainVPContainer'),
        rectElement: document.querySelector('.teasers__ui'),
        zero: {x: 0.5, y: 0.5},
        numAveraging: 5,
        points: [],
        timestamps: [],
        start: function (model) {
            this.model = model;
            if (!this.model) {
                this.stop();
                return;
            }
            if (this.isTouch)
            {
                this._lr = this.touchHandler.bind(this);
                this.element.addEventListener('touchmove', this._lr);
            }
            else
            {
                this._lr = this.moveHandler.bind(this);
                this.element.addEventListener('mousemove', this._lr);
            }
        },
        stop: function () {
            if (!this._lr) return;
            if (this.isTouch)
                this.element.removeEventListener('touchmove', this._lr);
            else
                this.element.removeEventListener('mousemove', this._lr);
            this._lr = null;
        },
        moveHandler: function (event) {
            //console.log(event);
            this._addPoint(event.clientX || event.pageX, event.clientX || event.pageX);

        },
        touchHandler: function (event) {
            //console.log(event)
            let obj = event.targetTouches || event.touches;
            if (!obj) return;
            obj = obj[0];
            this._addPoint(obj.clientX || obj.pageX, obj.clientX || obj.pageX);
        },
        _addPoint: function (x, y) {
            let t = new Date().getTime();
            let vx = 0;
            let vy = 0;
            let tch0;
            let tch;
            let rect = this.element.getBoundingClientRect();

            if (!rect || !rect.width || !rect.height) return;

            let x1 = x - this.zero.x * rect.width;
            let y1 = y - this.zero.y * rect.height;

            if (this._to) { clearTimeout(this._to); this._to = null; }

            while(this.points.length > this.numAveraging || this.points.length > 0 && t - this.timestamps[0] > 600)
            {
                this.points.shift();
                this.timestamps.shift();
            }

            this.points.push({x: x1, y: y1});
            this.timestamps.push(t);

            let i = 0;
            if (this.points.length > 1)
            {
                while (i < this.points.length - 1)
                {
                    tch0 = this.points[i];
                    tch = this.points[i+1];
                    t = this.timestamps[i+1] - this.timestamps[i];
                    vx += (tch.x - tch0.x) / t;
                    vy += (tch.y - tch0.y) / t;
                    i++;
                }
                vx /= i;
                vy /= i;
                vx *= 1000;
                vy *= 1000;
            }

            this.model.point = {x: x1, y: y1};
            this.model.pointRelative = {x: x1/rect.width, y: y1/rect.height};
            this.model.velocity = {x: vx, y: vy};
            this.model.velocityRelative = {x: vx/rect.width, y: vy/rect.height};

            this._to = setTimeout(function () {
                if (this.points.length < 1) return;
                this.model.velocity = {x: 0, y: 0};

                this.points.splice(0, this.points.length);
                this.timestamps.splice(0, this.timestamps.length);
            }.bind(this), 599);
        }
    }


    // 2. Model object
        root.coreModel = ((currentRoute, routesMap) => {
            function Model(currentRoute, routesMap) {
                this._currentRoute = null;
                this._newRoute = currentRoute;
                this._routesMap = routesMap;
                this.dataStorage = new AbstractMediaStorage();

                this._mainStarted = !this.isNewRouteMain();
                this._routeStarted = false;
                this._routeSecondScroll = false;

                this._currentMaxRouteScroll = 0;
            }

            const p = Model.prototype;

            // Add Event Dispatcher methods
            createjs.EventDispatcher.initialize(p);

            p.isMain = function () {
                return this._currentRoute.toLowerCase() === 'main';
            };

            p.isNewRouteMain = function () {
                return this._newRoute !== null && this._newRoute.toLowerCase() === 'main';
            };

            p.mainStarted = function (value) {
                if (typeof value === "undefined" || !value || this._mainStarted === value)
                    return this._mainStarted;
                this._mainStarted = value;
                this.dispatchEvent("mainStart");
                return this._mainStarted;
            };

            p.routeStarted = function (value) {
                if (typeof value === "undefined" || this._routeStarted === value)
                    return this._routeStarted;


                if (!value && this._currentRouteScroll < 20) return;

                // RESET SCROLL
                if (value)
                {
                    this._currentRouteScroll = 0;

                    // Timeout to prevent autoplay
                    //console.log(this.routeStartTime, new Date().getTime(), new Date().getTime() - this.routeStartTime)
                    if (new Date().getTime() - this.routeStartTime < 500) return;
                }

                this._routeStarted = value;
                this.dispatchEvent("routeStartChanged");

                return this._routeStarted;
            };

            p.routeSecondScroll = function (value) {
                if (typeof value === "undefined" || this._routeSecondScroll === value)
                    return this._routeSecondScroll;
                this._routeSecondScroll = value;
                return this._routeSecondScroll;
            };

            p.hasNewRoute = function () {
                return this._newRoute !== null && this._routesMap.hasOwnProperty(this._newRoute);
            };

            p.getNewRoute = function () {
                return this._newRoute;
            };

            p.getCurrentRoute = function () {
                return this._currentRoute;
            };

            p.getNewRouteSrc = function () {
                return this._routesMap[this._newRoute];
            };

            p.gotoRoute = function (id) {
                if (id === this._currentRoute) return;
                this._newRoute = id;
                this.dispatchEvent("routeNeedsChange");
            };

            p.setRouteName = function (id, name) {
                this._routeNames = this._routeNames || {};
                this._routeNames[id] = name;
                return name;
            };

            p.getRouteName = function (id) {
                if (!this._routeNames) return null;
                return this._routeNames[id];
            };

            p.routeReady = function (id) {
                if (id !== this._newRoute) return;
                this._currentRoute = this._newRoute;
                this._newRoute = null;
                this._routeStarted = false;
                this._routeSecondScroll = false;
                this._currentMaxRouteScroll = 0;
                this._currentRouteScrollStage = 0;
                this.dispatchEvent("routeReady");
            };

            p.resetNewRoute = function () {
                this._newRoute = null;
            };

            p.currentRouteScroll = function (value) {
                if (typeof value === "undefined" || this._currentMaxRouteScroll === value)
                    return this._currentMaxRouteScroll;

                if (this._currentRouteScroll < value)
                    this._currentRouteScroll = value;

                // Store the maximum value only
                if (this._currentMaxRouteScroll > value) return this._currentMaxRouteScroll;

                let stage = Math.floor(value / 25);
                this._currentMaxRouteScroll = value;

                if (this._currentRouteScrollStage === stage) return this._currentMaxRouteScroll;

                this._currentRouteScrollStage = stage;
                let event = new createjs.Event('scrollPercentage');
                event.percent = parseInt(stage * 25);
                this.dispatchEvent(event);
            };

            return new Model(currentRoute, routesMap);
        })(

    // Step 1. Define initial Route
            root.domStateStore.getState("currentRoute"),
            {
                'story_1': 'story_1.html',
                'story_2': 'story_2.html',
                'story_3': 'story_3.html',
                'story_4': 'story_4.html',
                'story_5': 'story_5.html'
            }
        );

    // II. View classes:
        root.view = ((mainCntr, artclCntr, artclVP, hdr) => {

            ////////////////////////////////////////////
            // Total View:
            function View(main, artclVP, hdr) {
                this.main = main;
                this.artclVP = artclVP;
                this.html = document.querySelector('html');
                this.body = document.querySelector('body');
                this.hdr = hdr;
                this._hdrPseudoVP = new VP(hdr);
                this._hdrPseudoVP.initResizeElements();

                this._mfxModel = {};

                createjs.Ticker._setFPS(25);
            }

            const p = View.prototype;

            // Add Event Dispatcher methods
            createjs.EventDispatcher.initialize(p);


            p.gotoMain = function (startScreen) {
                this._ghostToTop();

                this.main.activate();
                if (this.artcl)
                {

                    // LINKS TACKERS
                    this._untrackOutbound_('.js-vizarsinLogo', this.artclVP.container);
                    this._untrackOutbound_('.js-vizarsinLink', this.artclVP.container);
                    this._untrackOutbound_('.js-branding', this.artclVP.container);
                    this.artcl.activate(false);
                    this.artcl = null;
                }
                this.hdr.classList.remove('inactive');

                if (startScreen)
                {
                    this.main.showStartScreen();
                    this.main.stopTeasers();

                    if (!this._startLr)
                    {
                        this._startLr = onStart.bind(this);
                        this.main.startBtn.addEventListener('click', this._startLr);
                    }
                }
                else
                {
                    this.startMain();
                }


                uiTouch.start();


                this.main.plane.setModel(this._mfxModel);
                mfxUpdater.start(this._mfxModel);

                // Teasers UI ON
                uiEvents.start();
                if (!this._clickLr)
                {
                    this._clickLr = onClick.bind(this);
                    uiEvents.addEventListener('clickTeaser', this._clickLr)
                }

                // Article UI OFF
                if (this._nextLr)
                {
                    [].forEach.call(this.artclVP.nextBtns, function(el) {
                        el.removeEventListener('click', this._nextLr)
                    }.bind(this));
                    this._nextLr = null;
                }

                // LINKS TACKERS
                if (!this._mainTrackersOn)
                {

                    this._trackOutbound_('.js-vizarsinLogo', 'Logo: Больше Дольше');
                    this._trackOutbound_('.js-passion', 'Logo: Passion Ru');

                    this._mainTrackersOn = true;
                }


                function onStart() {
                    this.dispatchEvent('startRequest');
                }

                function onClick(evt) {
                    const tgt = evt.targetElement;
                    if (!tgt) return;
                    const evt1 = new createjs.Event('gotoRequest');
                    evt1.routeId = dataUtils.getData(tgt, 'routeId');
                    this.dispatchEvent(evt1);
                }
            };

            p.startMain = function () {
                this.main.hideStartScreen();
                this.main.startTeasers();

                if (this._startLr)
                {
                    this.main.startBtn.removeEventListener('click', this._startLr);
                    delete this._startLr;
                }
            }

            p.startRoute = function () {
                if (!this.artcl) return;

                this.artcl.start();

                if (this._startScrollTO) { clearTimeout(this._startScrollTO); this._startScrollTO = null; }
                this._startScrollTO = setTimeout(function () {
                    this.switchScrollOn();
                }.bind(this), 1000);
            }

            p.switchScrollOn = function () {
                if (this._startScrollTO) { clearTimeout(this._startScrollTO); this._startScrollTO = null; }
                this.html.classList.remove('body_100');
                this.body.classList.remove('body_100');
                this._scrollOn = true;
            }

            p.switchScrollOff = function () {
                if (this._startScrollTO) { clearTimeout(this._startScrollTO); this._startScrollTO = null; }
                this.html.classList.add('body_100');
                this.body.classList.add('body_100');
                this._scrollOn = false;
            }

            p.backToRouteStart = function () {
                if (!this.artcl) return;

                this.artcl.toStart();
            }

            p.displayCurrentArticle = function () {
                this._undoGhostToTop();

                uiTouch.pause();
                mfxUpdater.stop();
                uiEvents.pause(true);

                this.artcl = new Article(this.artclVP.container, this.artclVP);

                this.main.activate(false);
                this.main.hideStartScreen();
                this.main.stopTeasers();
                this.main.plane.release();
                this.hdr.classList.add('inactive');

                this.artcl.activate();

                // Teasers UI OFF
                if (!this._clickLr)
                {
                    uiEvents.removeEventListener('clickTeaser', this._clickLr);
                    this._clickLr = null;
                }
                uiEvents.pause();

                // Article UI ON
                if (!this._nextLr)
                {
                    this._nextLr = onNext.bind(this);
                    [].forEach.call(this.artclVP.nextBtns, function(el) {
                        el.addEventListener('click', this._nextLr)
                    }.bind(this));
                }



                // LINKS TACKERS
                this._trackOutbound_('.js-vizarsinLogo', 'Logo Больше Дольше', this.artclVP.container);
                this._trackOutbound_('.js-vizarsinLink', 'Link Больше Дольше', this.artclVP.container);
                this._trackOutbound_('.js-branding', 'Branding Больше Дольше', this.artclVP.container);


                function onNext() {
                    this.dispatchEvent('nextArticleRequest');
                }
            };

            p.start = function () {
                this.main.init();
                window.addEventListener('resize', this.handleResize.bind(this));
                window.addEventListener('scroll', this.handleScroll.bind(this));
                window.addEventListener('mousewheel', this.handleMousewheel.bind(this));
                window.addEventListener('touchstart', this.handleTouchstart.bind(this));
                window.addEventListener('touchend', this.handleTouchend.bind(this));
                window.addEventListener('touchmove', this.handleTouchmove.bind(this));

                setTimeout(this.handleResize.bind(this), 200);
            };

            p.handleResize = function () {
                this.main.onResize();
                if (this.artcl) this.artcl.onResize();
                this._hdrPseudoVP.updateResizeElements();

                this.handleScroll(false);
            };

            p.handleScroll = function (evt) {
                if (!this._scrollOn) return;
                if (!this.artcl) return;

                if (evt) {
                    if (root.getWinScrollTop() < 2)
                        this.dispatchEvent('restartRouteRequest');
                }

                // TRACK SCROLL PORTIONS


                let h0 = root.winOffsetHeight();
                let h1 = root.docHeight();
                let t = root.getWinScrollTop();
                let event = new createjs.Event('scrollPercent');

                if (h1 <= h0){
                    // 100%
                    event.percent = 100;
                }
                else
                {
                    t = 100 * t / (h1 - h0 * 1.01);
                    event.percent = t;
                }
                this.dispatchEvent(event);


                this.artcl.onScroll(evt);
            };

            p.handleMousewheel = function (evt) {
                if (this._scrollOn || !this.artcl) return;

                if (evt.deltaY && evt.deltaY > 0)
                    this.dispatchEvent('startRouteRequest');
            }

            p.handleTouchstart = function (evt) {
                if (this._scrollOn || !this.artcl) return;

                try {
                    this._touchY0 = (evt.changedTouches || evt.touches)[0].screenY;
                } catch(e) {}
            }

            p.handleTouchmove = function (evt) {
                if (this._scrollOn || !this.artcl || typeof this._touchY0 === "undefined") return;

                try {
                    if ((evt.changedTouches || evt.touches)[0].screenY - this._touchY0 < 0)
                        this.dispatchEvent('startRouteRequest');
                } catch(e) {}
            }

            p.handleTouchend = function () {
                if (this._scrollOn || !this.artcl) return;

                this._touchY0 = undefined;
            }

            p._ghostToTop = function () {
                let y0 = root.getWinScrollTop();
                let h = root.winOffsetHeight();
                window.scrollTo(0, 0);
                TweenMax.set(this.artclVP.container, {y: -y0});
                TweenMax.set(this.artclVP.container, {delay:0.4, y: -y0-h/2});
            }

            p._undoGhostToTop = function () {
                TweenMax.set(this.artclVP.container, {y: 0});
            }

            p._trackOutbound_ = function(selector, label, root)
            {
                let elem = root ? [...root.querySelectorAll(selector)] : [...document.querySelectorAll(selector)];
                elem.forEach(function (el) {

                    let f = function () {
                        let event = new createjs.Event('Outbound');
                        event.label = label;
                        this.dispatchEvent(event);
                    }.bind(this);

                    dataUtils.setData(el, 'ltOutbound', f);
                    el.addEventListener("click", f);
                }.bind(this));
            }

            p._untrackOutbound_ = function(selector, root)
            {
                let elem = root ? [...root.querySelectorAll(selector)] : [...document.querySelectorAll(selector)];
                elem.forEach(function (el) {
                    let f = dataUtils.getData(el, 'ltOutbound');
                    el.removeEventListener("click", f);
                });
            }

            //////////////////////////////////////
            // Main page view:
            function MainView(vp) {
                this.vp = vp;
                this.vp.initResizeElements();

                this._startShown = false;

                this._teasersCTA = this.vp.container.querySelector('.teasersCTA');

                // Elements:
                this._teasersRoot = this.vp.container.querySelector('.js-teasers');
                this._welcomeRoot = this.vp.container.querySelector('.js-welcome');

                this.startBtn = this.vp.container.querySelector('.js-start');

                this.plane = new Plane(this.vp.container.querySelector('.teasers__picture'))
            }

            const p1 = MainView.prototype;

            p1.init = function () {
                // Teasers:
                this._teasers = {};
                const elems = [...this._teasersRoot.querySelectorAll('.teaser')];
                let elem;
                let bbl;
                let key;
                for (elem of elems)
                {
                    key = dataUtils.getData(elem, 'key');
                    bbl = this._teasersRoot.querySelector(`.bubble[data-key=${key}]`);
                    this._teasers[key] = new Teaser(elem.querySelector('canvas'), bbl);
                }
            }

            p1.activate = function (b) {
                this.vp.activate(b);
                if (b)
                    this.vp.updateResizeElements();
            };

            p1.onResize = function () {
                this.vp.updateResizeElements();
            };

            p1.showStartScreen = function () {
                if (this._startShown) return;

                this._startShown = true;

                let elems = getCanvases(this._welcomeRoot);
                let elem;
                let anim;
                startStages(elems);
                for (elem of elems)
                {
                    anim = dataUtils.getData(elem, 'animation');
                    if (anim)
                        anim.gotoAndPlay('start');
                }

                startStages(getSVGs(this._welcomeRoot));

                this._welcomeRoot.classList.add('welcome_onoff_on');
                this._welcomeRoot.classList.remove('welcome_onoff_off');
            };

            p1.hideStartScreen = function () {
                if (!this._startShown) return;

                this._startShown = false;

                const elems = getCanvases(this._welcomeRoot);
                let elem;
                let anim;
                for (elem of elems)
                {
                    anim = dataUtils.getData(elem, 'animation');
                    if (anim)
                    {
                        anim.on("animationend", function () {
                            setTimeout(this.stopStartScreen.bind(this), 500);
                        }, this, true);
                        anim.gotoAndPlay('hide');
                    }
                }

                this._welcomeRoot.classList.add('welcome_onoff_off');
                this._welcomeRoot.classList.remove('welcome_onoff_on');
            };

            p1.stopStartScreen = function () {
                stopStages(getCanvases(this._welcomeRoot));
                stopStages(getSVGs(this._welcomeRoot));
            }

            p1.startTeasers = function () {
                if (this._teasersTO) {clearTimeout(this._teasersTO); delete this._teasersTO; }

                this._teasersRoot.classList.add('teasers_onoff_on');
                this._teasersRoot.classList.remove('teasers_onoff_off');

                if (this._teasersTO) {clearTimeout(this._teasersTO); this._teasersTO = null;}
                this._teasersCTA.classList.add('teasersCTA_on');
                this._teasersCTA.classList.remove('teasersCTA_off');

                // UI ON
                this._hrLr1 = this._onHoverTeaser.bind(this);
                this._hrLr2 = this._onOutTeaser.bind(this);
                uiEvents.addEventListener('overTeaser', this._hrLr1);
                uiEvents.addEventListener('outTeaser', this._hrLr2);


                // STAGES ON
                startStages(getCanvases(this._teasersRoot));
                startStages(getSVGs(this._teasersRoot));
            };

            p1.stopTeasers = function () {
                if (this._teasersTO) {clearTimeout(this._teasersTO); delete this._teasersTO; }

                this._teasersRoot.classList.add('teasers_onoff_off');
                this._teasersRoot.classList.remove('teasers_onoff_on');

                if (this._teasersTO) {clearTimeout(this._teasersTO); this._teasersTO = null;}
                this._teasersCTA.classList.remove('teasersCTA_on');
                this._teasersCTA.classList.add('teasersCTA_off');

                // UI OFF

                uiEvents.removeEventListener('overTeaser', this._hrLr1);
                uiEvents.removeEventListener('outTeaser', this._hrLr2);

                this._hrLr1 = null;
                this._hrLr2 = null;

                let key;
                for (key in this._teasers)
                {
                    if (this._teasers.hasOwnProperty(key))
                        this._teasers[key].hide();
                }

                this._teasersTO = setTimeout(function () {
                    this._stopTeasers();
                }.bind(this), 1000);
            };

            p1._stopTeasers = function () {
                if (this._teasersTO) {clearTimeout(this._teasersTO); delete this._teasersTO; }

                // STAGES OFF
                stopStages(getCanvases(this._teasersRoot));
                stopStages(getSVGs(this._teasersRoot));
            };

            p1._onHoverTeaser = function (evt) {
                const tgt = evt.targetElement;
                if (!tgt) return;
                const key = dataUtils.getData(tgt, 'hoverKey');
                if (!key || !this._teasers.hasOwnProperty(key)) return;

                this._teasers[key].over();
                this._teasersRoot.classList.remove('teasers_over_off');
                this._teasersRoot.classList.add('teasers_over_on');

                if (this._teasersTO) {clearTimeout(this._teasersTO); this._teasersTO = null;}
                this._teasersCTA.classList.remove('teasersCTA_on');
                this._teasersCTA.classList.add('teasersCTA_off');

                root.domStateStore.setState('teasersOver', 'on', true);
            }

            p1._onOutTeaser = function (evt) {
                const tgt = evt.targetElement;
                if (!tgt) return;
                const key = dataUtils.getData(tgt, 'hoverKey');
                if (!key || !this._teasers.hasOwnProperty(key)) return;

                this._teasers[key].out();
                this._teasersRoot.classList.add('teasers_over_off');
                this._teasersRoot.classList.remove('teasers_over_on');

                if (this._teasersTO) {clearTimeout(this._teasersTO); this._teasersTO = null;}

                this._teasersTO = setTimeout(function () {
                    if (this._teasersTO) {clearTimeout(this._teasersTO); this._teasersTO = null;}
                    this._teasersCTA.classList.add('teasersCTA_on');
                    this._teasersCTA.classList.remove('teasersCTA_off');
                }.bind(this), 1000);

                root.domStateStore.setState('teasersOver', 'off', true);
            }

            //////////////////////////////////////
            // Common Viewport methods:
            function VP(container, vp) {
                this.container = container;
                this.vp = vp;
                this.resizeElements = null;

                this.nextBtns = [...this.container.querySelectorAll('.js-nextBtn')];
            }

            let p2 = VP.prototype;

            p2.activate = function (b) {
                if (typeof b === "undefined") b = true;
                if (b)
                {
                    if (this._clearTO) { clearTimeout(this._clearTO); this._clearTO = null; }
                    this.container.classList.add('active');
                }
                else
                    this.container.classList.remove('active');
            };

            p2.initResizeElements = function () {
                this.widthElements = [...this.container.querySelectorAll('[data-width-ref]')];
                this.widthElements.forEach(function (elem) {
                    let ref = dataUtils.getData(elem, 'widthRef');
                    dataUtils.setData(elem, 'sizeRefElement', document.querySelector(ref));
                });

                this.resizeElements = [...this.container.querySelectorAll('[data-size-ref]')];
                this.resizeElements.forEach(function (elem) {
                    let ref = dataUtils.getData(elem, 'sizeRef');
                    dataUtils.setData(elem, 'sizeRefElement', document.querySelector(ref));

                    switch (elem.nodeName.toLowerCase())
                    {
                        case 'canvas':
                            dataUtils.setData(elem, 'initialWidth', elem.getAttribute('width'));
                            dataUtils.setData(elem, 'initialHeight', elem.getAttribute('height'));
                            break;
                    }
                });
            };

            p2.updateResizeElements = function () {
                if (this.widthElements)
                {
                    this.widthElements.forEach(function (elem) {
                        let ref = dataUtils.getData(elem, 'sizeRefElement');

                        if (!ref) return;

                        let type = dataUtils.getData(elem, 'widthRefType') || '';
                        let w = ref.offsetWidth;
                        if (dataUtils.getData(elem, 'widthEven') && Math.ceil(w) % 2 > 0)
                            w =  Math.ceil(w) - 1;
                        if (type.length < 1)
                            elem.style.width = w+'px';
                        else
                        {
                            try {
                                elem.style[type+'Width'] = w+'px';
                            } catch (e) {}
                        }
                    })
                }
                if (!this.resizeElements) return;
                this.resizeElements.forEach(function (elem) {
                    let ref = dataUtils.getData(elem, 'sizeRefElement');

                    if (!ref) return;

                    let scaleType = dataUtils.getData(elem, 'scaleType') || 1;
                    let align = dataUtils.getData(elem, 'stageAlign') || 'TL';
                    let w = ref.offsetWidth;
                    let h = ref.offsetHeight;
                    let w0;
                    let h0;
                    let stage;
                    //let anim;
                    switch (elem.nodeName.toLowerCase())
                    {
                        case 'canvas':
                            w0 = dataUtils.getData(elem, 'initialWidth');
                            h0 = dataUtils.getData(elem, 'initialHeight');
                            stage = dataUtils.getData(elem, 'stage');
                            //anim = dataUtils.getData(elem, 'animation');

                            let pRatio = window.devicePixelRatio || 1, xRatio=w/w0, yRatio=h/h0, sRatio=1;
                            if(scaleType === 2) {
                                // COVER:
                                sRatio = Math.max(xRatio, yRatio);
                            }
                            else {
                                // Default CONTAIN:
                                sRatio = Math.min(xRatio, yRatio);
                            }
                            elem.width = w*pRatio;
                            elem.height = h*pRatio;
                            elem.style.width = w+'px';
                            elem.style.height = h+'px';
                            if (stage)
                            {
                                stage.scaleX = pRatio*sRatio;
                                stage.scaleY = pRatio*sRatio;

                                if (scaleType !== 2) {
                                    switch (align) {
                                        case 'B':
                                            stage.x = Math.floor((pRatio*w - pRatio*sRatio*w0) / 2);
                                            stage.y = Math.floor(pRatio*h - pRatio*sRatio*h0);
                                            break;
                                    }
                                }
                            }

                            break;
                    }
                })
            };

            p2.getCanvasElements = function (force) {
                this._canvases = force || !this._canvases ? getCanvases(this.container) : this._canvases;
                return this._canvases;
            };

            p2.getSVGElements = function (force) {
                this._svgs = force || !this._svgs ? getSVGs(this.container) : this._svgs;
                return this._svgs;
            };

            p2.clearContent = function (delay) {
                if (this._clearTO) { clearTimeout(this._clearTO); this._clearTO = null; }
                this._clearTO = setTimeout(clearContent.bind(this), delay);

                function clearContent() {
                    this.vp.innerHTML = '';
                }
            };


            //////////////////////////////////////
            // Article:
            function Article(container, vp) {
                this.container = container;
                this.vp = vp;

                this.artclElem = this.container.querySelector('.article');

                this.vp.initResizeElements();
            }

            p2 = Article.prototype;

            p2.activate = function (b) {
                this.vp.activate(b);
                setTimeout(this.vp.updateResizeElements.bind(this.vp), 200);

                if (b || typeof b === 'undefined')
                {
                    startStages(this.vp.getCanvasElements());
                    startStages(this.vp.getSVGElements());
                }
                else
                {
                    stopStages(this.vp.getCanvasElements());
                    stopStages(this.vp.getSVGElements());
                    stopAnims(this.vp.getSVGElements());
                    // this.vp.clearContent(1000);
                }
            };

            p2.onResize = function () {
                this.vp.updateResizeElements();
            };

            p2.start = function () {
                this.artclElem.classList.remove('article_started_no');
                this.artclElem.classList.add('article_started_yes');

                startAnims(this.vp.getSVGElements());
            };

            p2.toStart = function () {
                this.artclElem.classList.add('article_started_no');
                this.artclElem.classList.remove('article_started_yes');
                reverseAnims(this.vp.getSVGElements());
            };

            p2.onScroll = function () {

            };

            ////////////////////////////////

            ////////////////////////////////
            // Teaser:
            function Teaser(canvas, bubble) {
                this.bubble = bubble;
                this.anim = dataUtils.getData(canvas, 'animation');
                this._over = false;
            }

            p2 = Teaser.prototype;

            p2.start = function () {
                // Start animate bubble
            }

            p2.hide = function () {
                this.out();
                // hide bubble ?
                // Stop animate bubble
            }

            p2.over = function () {
                if (this._over) return;
                if (this.anim)
                    this.anim.gotoAndPlay('start');

                this.bubble.classList.add('bubble_over');
                this._over = true;
            }

            p2.out = function () {
                if (!this._over) return;
                if (this.anim)
                    this.anim.gotoAndPlay('hide');

                this.bubble.classList.remove('bubble_over');
                this._over = false;
            }

            ////////////////////////////////
            // Plane:
            function Plane(element, model) {
                this.elem = element;
                this.model = model;
            }

            p2 = Plane.prototype;

            p2.handleEvent = function (event) {
                if (event.type !== 'tick') return;

                // createjs.Ticker.getTicks(true)

                this._render();
            };

            p2.setModel = function (model) {
                this.model = model;
            }

            p2.start = function () {
                createjs.Ticker.addEventListener('tick', this);
            }

            p2.stop = function () {
                createjs.Ticker.removeEventListener('tick', this);
            }

            p2.release = function () {
                this.stop();
            }

            p2._render = function () {
                if (!this.model) return;

                //this.model.pointRelative
                //this.model.velocityRelative
            }




            // Internal utils functions
            function getCanvases(rootElem) {
                return [...rootElem.querySelectorAll('canvas[data-spritesheet]')];
            }

            function getSVGs(rootElem) {
                return [...rootElem.querySelectorAll('svg[data-src]')];
            }


            function startStages(elems) {
                let stage;
                let elem;
                for (elem of elems)
                {
                    stage = dataUtils.getData(elem, 'stage');
                    if (stage)
                        createjs.Ticker.addEventListener('tick', stage);
                }
            }

            function stopStages(elems) {
                let stage;
                let elem;
                for (elem of elems)
                {
                    stage = dataUtils.getData(elem, 'stage');
                    if (stage)
                        createjs.Ticker.removeEventListener('tick', stage);
                }
            }


            function startAnims(elems) {
                let stage;
                let tl;
                let elem;
                for (elem of elems)
                {
                    tl = dataUtils.getData(elem, 'tl');
                    if (tl)
                        tl.play();

                    stage = dataUtils.getData(elem, 'animStage');
                    if (stage)
                        createjs.Ticker.addEventListener('tick', stage);
                }
            }

            function reverseAnims(elems) {
                let stage;
                let tl;
                let elem;
                let b;
                for (elem of elems)
                {
                    tl = dataUtils.getData(elem, 'tl');
                    b = dataUtils.getData(elem, 'animRevesable');
                    if (tl)
                    {
                        if (b)
                            tl.reverse();
                        else
                            tl.pause();
                    }

                    stage = dataUtils.getData(elem, 'animStage');
                    if (stage)
                    {
                        createjs.Ticker.removeEventListener('tick', stage);
                        stage.reset();
                    }
                }
            }

            function stopAnims(elems) {
                let stage;
                let tl;
                let elem;
                for (elem of elems)
                {
                    tl = dataUtils.getData(elem, 'tl');
                    if (tl)
                        tl.pause();

                    stage = dataUtils.getData(elem, 'animStage');
                    if (stage)
                    {
                        createjs.Ticker.removeEventListener('tick', stage);
                        stage.reset();
                    }
                }
            }

            return new View(new MainView(new VP(mainCntr, null)), new VP(artclCntr, artclVP), hdr);
        })(
            document.querySelector('.js-mainVPContainer'),
            document.querySelector('.js-articleVPContainer'),
            document.querySelector('.js-articleVP'),
            document.querySelector('.js-header')
        );


    // III. Controller:
        root.controller = ((model, view) => {
            function Controller(model, view) {
                this.model = model;
                this.view = view;

                let cmd1 = new LoadNewRouteHTMLCommand(model, view);
                cmd1.registerCompleteCallback(this.onLoadNewRoute, this);

                this.prepareNewRoute = new MacroCommand();
                this.prepareNewRoute.reusable = true;
                this.prepareNewRoute.add(cmd1);
                this.prepareNewRoute.add(new PrepareRouteCanvasCommand(model, view));
                this.prepareNewRoute.add(new PrepareRouteSVGsCommand(model, view));

                this.readyNewRoute = new NewRouteReadyCommand(model, view);

            }

            const p = Controller.prototype;

            p.init = function () {


                // GET ROUTES DATA
                let routes = [...document.querySelectorAll('.js-ui [data-route-id]')];
                let i = 0;
                let route;
                let s;
                for (i = 0; i < routes.length; i++)
                {
                    route = routes[i];
                    s = dataUtils.getData(route, 'routeName');
                    if (s)
                        this.model.setRouteName(dataUtils.getData(route, 'routeId'), s);
                }
                this.model.setRouteName('main', 'Girls Section');

                let cmd = new MacroCommand();
                let currRoute = this.model.getNewRoute();
                this.readyNewRoute.setRouteId(currRoute);

                if (!this.model.isNewRouteMain())
                {
                    this.model.gotoRoute('main');

                    this.prepareNewRoute.registerCompleteCallback(function () {
                        this.model.gotoRoute(currRoute);
                    }, this);

                    cmd.add(this.prepareNewRoute);
                }

                cmd.add(this.prepareNewRoute);
                cmd.add(this.readyNewRoute);

                cmd.registerCompleteCallback(function () {
                    this.prepareNewRoute.removeListeners();
                }, this);
                cmd.registerCompleteCallback(this.start, this);
                cmd.execute();

            };

            p.start = function () {

                uiTouch.init();
                uiEvents.init();

                if (this.model.isMain())
                {
                    if (this._checkNeedStartRoute()) this.view.switchScrollOff();
                    this.view.gotoMain(!this.model.mainStarted());
                }
                else
                {
                    if (this._checkNeedStartRoute()) this.view.switchScrollOff();
                    this.view.displayCurrentArticle();
                    if (this._checkWinToStartArticle())
                    {
                        this.model.routeStartTime = new Date().getTime() - 1500;
                        this.model.routeStarted(true);
                    }
                    else
                    {
                        this.model.routeStartTime = new Date().getTime();
                    }
                }

                this.view.start();

                this._scrollCTA = document.querySelector('.js-scrollCTA');
                if (this._scrollCTA)
                    this._scrollCTA.addEventListener('click', this._scrollCTAHandler.bind(this));

                this._upBtn = document.querySelector('.js-upButton');
                if (this._upBtn)
                    this._upBtn.addEventListener('click', this._upButtonHandler.bind(this));

                this._addModelListeners();
                this._addViewListeners();
                root.preloadingComplete();
            }

            p._addModelListeners = function () {
                this.model.on('routeReady', this._handleRouteReady, this);
                this.model.on('mainStart', this._handleMainStart, this, true);
                this.model.on('routeStartChanged', this._handleRouteStartChanged, this);
                this.model.on('routeNeedsChange', this._handleRouteNeedsChange, this);
                this.model.on('scrollPercentage', this._handleScrollPercentage, this);
            }

            p._addViewListeners = function () {
                this.view.on('startRequest', this._view_handleStartRequest, this);
                this.view.on('gotoRequest', this._view_handleGotoRequest, this);
                this.view.on('nextArticleRequest', this._view_handleNextArticleRequest, this);
                this.view.on('scrollPercent', this._view_handleScrollPercent, this);
                this.view.on('Outbound', this._view_handleOutbound, this);

                this.view.on('restartRouteRequest', this._view_handleRestartRouteRequest, this);
                this.view.on('startRouteRequest', this._view_handleStartRouteRequest, this);
            }

            p._handleRouteReady = function () {
                if (this.model.isMain())
                {
                    this.view.gotoMain(!this.model.mainStarted());
                    if (this._checkNeedStartRoute()) this.view.switchScrollOff();
                }
                else
                {
                    this._resetScrollCTA();
                    if (this._checkNeedStartRoute()) this.view.switchScrollOff();
                    this.view.displayCurrentArticle();
                    if (this._checkWinToStartArticle())
                    {
                        this.model.routeStartTime = new Date().getTime() - 1500;
                        this.model.routeStarted(true);
                    }
                    else
                    {
                        this.model.routeStartTime = new Date().getTime();
                    }
                }

                root.domStateStore.setState('currentRoute', this.model.getCurrentRoute(), true);
            }

            p._handleMainStart = function () {
                this.view.startMain();
            }

            p._handleRouteStartChanged = function () {

                if (this.model.routeStarted())
                {
                    if (this._checkNeedStartRoute()) {
                        window.analyticsEvent('Scroll', 'scroll', {eventLabel: this.model.getRouteName(this.model.getCurrentRoute()) + ': First Scroll'});

                        let y = root.winOffsetHeight() * 0.1;
                        TweenLite.to('.page', 1, {
                            y: -y,
                            ease: Sine.easeInOut,
                            onStart: function () {
                                window.scrollTo(0, 0);
                                preventScroll.on();
                            },
                            onComplete: function () {

                                preventScroll.off();
                                this.view.switchScrollOn();
                                window.scrollTo(0, y);
                                TweenLite.set('.page', {y: 0});
                            }.bind(this)
                        });
                    }
                    this.view.startRoute();
                    this._scrollCTA.classList.add('page__viewport__scrollCTA_down');

                    return;
                }

                this.view.backToRouteStart();
                if (this._checkNeedStartRoute()) this.view.switchScrollOff();
                this._resetScrollCTA();
            }

            p._handleRouteNeedsChange = function () {
                let cmd = new MacroCommand();
                this.readyNewRoute.setRouteId(this.model.getNewRoute());

                cmd.add(this.prepareNewRoute);
                cmd.add(this.readyNewRoute);
                cmd.execute();
            }

            p._handleScrollPercentage = function (evt) {
                window.analyticsEvent('Scroll', 'percentage', {eventLabel: this.model.getRouteName(this.model.getCurrentRoute()) + ': Percents ' + evt.percent});
            }

            p._view_handleScrollPercent = function (evt) {
                this.model.currentRouteScroll(evt.percent);
            }

            p._view_handleOutbound  = function (evt) {

                window.analyticsEvent('Outbound', 'click', {eventLabel: this.model.getRouteName(this.model.getCurrentRoute()) + ': ' + evt.label});
            }

            p._view_handleStartRequest = function () {
                window.analyticsEvent('Start Button', 'click', {eventLabel: 'Start: Girls Section'});
                this.model.mainStarted(true);
            }

            p._view_handleGotoRequest = function (evt) {
                window.analyticsEvent('Section', 'click', {eventLabel: this.model.getRouteName(evt.routeId)});
                this.model.gotoRoute(evt.routeId);
            }

            p._view_handleStartRouteRequest = function (evt) {
                if (this.model.routeStarted())
                {
                    // secondScroll
                    if (evt && this._checkNeedStartRoute() && !this.model.routeSecondScroll())
                    {
                        window.analyticsEvent('Scroll', 'scroll', {eventLabel: this.model.getRouteName(this.model.getCurrentRoute()) + ': Second Scroll'});
                        this.model.routeSecondScroll(true);
                    }

                    if (document.querySelector("#secondScroll").getBoundingClientRect().top <= 0)
                        this._scrollCTA.classList.add('page__viewport__scrollCTA_hide');
                }
                this.model.routeStarted(true);
            }

            p._view_handleRestartRouteRequest = function () {
                this.model.routeStarted(false);
            }

            p._view_handleNextArticleRequest = function () {
                window.analyticsEvent('Back Button', 'click', {eventLabel: 'Girls Section from ' + this.model.getRouteName(this.model.getCurrentRoute())});
                this.model.gotoRoute('main');
            }

            p._scrollCTAHandler = function () {
                if (this.model.routeStarted())
                {
                    if (!this.model.routeSecondScroll())
                    {
                        window.analyticsEvent('Scroll', 'click', {eventLabel: this.model.getRouteName(this.model.getCurrentRoute()) + ': Second Scroll (Button click)'});
                        this.model.routeSecondScroll(true);

                        TweenLite.to(window, 1, {
                            scrollTo:{y:"#secondScroll", autoKill:false},
                            ease: Sine.easeInOut
                        });
                        this._scrollCTA.classList.add('page__viewport__scrollCTA_hide');
                    }

                    return;
                }
                if (this._checkNeedStartRoute()) {
                    window.analyticsEvent('Scroll', 'click', {eventLabel: this.model.getRouteName(this.model.getCurrentRoute()) + ': First Scroll (Button click)'});
                }
                this._view_handleStartRouteRequest(null);
            }

            p._resetScrollCTA = function () {
                this._scrollCTA.classList.remove('page__viewport__scrollCTA_down');
                this._scrollCTA.classList.remove('page__viewport__scrollCTA_hide');
            }

            p._upButtonHandler = function () {
                window.analyticsEvent('Scroll', 'click', {eventLabel: this.model.getRouteName(this.model.getCurrentRoute()) + ': Scroll Up (Button click)'});

                TweenLite.to(window, 0.7, {scrollTo:{y:0, autoKill:false, ease: Cubic.easeInOut}});
            }

            p.onLoadNewRoute = function (success) {
                if (!success)
                {
                    this.cancelGettingNewRoute();
                    // TODO: Display error message
                }
            };

            p.cancelGettingNewRoute = function () {
                this.prepareNewRoute.cancel();
                this.model.resetNewRoute();
            };

            p._checkWinToStartArticle = function () {
                // Portrait orientation
                return root.winOffsetWidth() < root.winOffsetHeight() || root.winOffsetWidth() < 769;
            };

            p._checkNeedStartRoute = function () {
                // Portrait orientation
                return root.winOffsetWidth() > root.winOffsetHeight() && root.winOffsetWidth() > 768;
            };



            //////////////////////////////////////
            // COMMANDS:
            // Load HTML:
            function LoadNewRouteHTMLCommand(model, view) {
                this.model = model;
                this.reusable = true;
                this.loadArticleHTML = new LoadHTMLCommand(null, null, view.artclVP.vp);
                this.loadArticleHTML.reusable = true;
                this.loadArticleHTML.registerCompleteCallback(this._ready, this);
            }

            let c1 = LoadNewRouteHTMLCommand;
            createjs.extend(c1, AsyncCommand);
            let p1 = c1.prototype;

            p1.execute = function () {
                this.AsyncCommand_execute.apply(this);
                if (this.model.isNewRouteMain()) { this.dispatchComplete(true); return; }
                if (!this.model.hasNewRoute()) { this.dispatchComplete(false); return; }
                this.loadArticleHTML.execute(this.model.getNewRoute(), this.model.getNewRouteSrc());
            };

            p1.cancel = function () {
                if (this.loadArticleHTML.cancelable)
                    this.loadArticleHTML.cancel();
                this.AsyncCommand_cancel.apply(this);
            };

            p1._ready = function (success) {
                this.dispatchComplete(success);
            }

            createjs.promote(c1, "AsyncCommand");


            // Prepare all the route canvas elements:
            function PrepareRouteCanvasCommand(model, view) {
                this.model = model;
                this.view = view;
            }

            c1 = PrepareRouteCanvasCommand;
            createjs.extend(c1, AsyncCommand);
            p1 = c1.prototype;

            p1.execute = function () {
                this.AsyncCommand_execute.apply(this);
                const vp = this.model.isNewRouteMain() ? view.main.vp : view.artclVP;
                const elems = vp.getCanvasElements(true);
                let elem;
                let s;
                let id;
                let n = 0;
                let cmd = new MacroCommand();
                let manifest = {"manifest": []};
                cmd.add(new LoadMediaCommand(manifest, this.model.dataStorage));
                manifest = manifest.manifest;
                for (elem of elems)
                {
                    s = dataUtils.getData(elem, 'spritesheet');
                    id = this.model.getNewRoute() + '_ssh_' + n;
                    manifest.push({
                        "src": s,
                        "id": id,
                        "type": "spritesheet"
                    });
                    cmd.add(new PrepareCanvasStageCommand(elem, id, this.model.dataStorage));
                    n++;
                }
                cmd.registerCompleteCallback(this._ready, this);
                cmd.execute();
            };

            p1._ready = function (success) {
                this.dispatchComplete(success);
            }

            createjs.promote(c1, "AsyncCommand");



            // Prepare canvas stage:
            function PrepareCanvasStageCommand(elem, spriteSheetId, ds) {
                this.elem = elem;
                this.spriteSheetId = spriteSheetId;
                this.ds = ds;
            }

            c1 = PrepareCanvasStageCommand;
            createjs.extend(c1, AsyncCommand);
            p1 = c1.prototype;

            p1.execute = function () {
                this.AsyncCommand_execute.apply(this);
                if (dataUtils.getData(this.elem, 'stage')) { this.dispatchComplete(true); return; }

                const stage = new createjs.Stage(this.elem);
                stage.log = [];

                const ssh = this.ds.getSpritesheetById(this.spriteSheetId);

                const sp = new createjs.Sprite(ssh);
                sp.x = 0;
                sp.y = 0;

                 /*   Test Anchor*/
                /*const rect = new createjs.Shape();
                let g = rect.graphics;
                g.beginFill("red");
                g.moveTo(0, 0);
                g.lineTo(10, 0);
                g.lineTo(10, 10);
                g.lineTo(0, 10);
                g.lineTo(0, 0);
                g.endFill();
                stage.addChild(rect);*/

                stage.addChild(sp);

                dataUtils.setData(this.elem, 'stage', stage);
                dataUtils.setData(this.elem, 'animation', sp);

                if (!ssh.complete) {
                    ssh.addEventListener("complete", this._ready, this, true);
                    return;
                }

                this.dispatchComplete(true);
            };

            p1._ready = function () {
                this.dispatchComplete(true);
            }

            createjs.promote(c1, "AsyncCommand");


            // Prepare all the route canvas elements:
            function PrepareRouteSVGsCommand(model, view) {
                this.model = model;
                this.view = view;
            }

            c1 = PrepareRouteSVGsCommand;
            createjs.extend(c1, AsyncCommand);
            p1 = c1.prototype;

            p1.execute = function () {
                this.AsyncCommand_execute.apply(this);
                const vp = this.model.isNewRouteMain() ? view.main.vp : view.artclVP;
                const elems = vp.getSVGElements(true);
                let elem;
                let s;
                let cmd = new MacroCommand();
                for (elem of elems)
                {
                    s = dataUtils.getData(elem, 'src');
                    if (!s)
                        continue;

                    cmd.add(new LoadHTMLCommand(s, s, null, this.model.dataStorage));
                    cmd.add(new PrepareSVGCommand(elem, s, this.model.dataStorage));
                }
                cmd.registerCompleteCallback(this._ready, this);
                cmd.execute();
            };

            p1._ready = function (success) {
                this.dispatchComplete(success);
            }

            createjs.promote(c1, "AsyncCommand");



            // Prepare canvas stage:
            function PrepareSVGCommand(elem, src, ds) {
                this.elem = elem;
                this.src = src;
                this.ds = ds;
            }

            c1 = PrepareSVGCommand;
            createjs.extend(c1, AsyncCommand);
            p1 = c1.prototype;

            p1.execute = function () {
                this.AsyncCommand_execute.apply(this);
                if (dataUtils.getData(this.elem, 'stage')) { this.dispatchComplete(true); return; }

                if (!this.ds) {
                    this.dispatchComplete(false);
                    return;
                }
                let html = this.ds.getHTML(this.src);
                if (!html) {
                    this.dispatchComplete(false);
                    return;
                }

                const parser = new DOMParser();
                const elSVG = parser.parseFromString(html, "image/svg+xml").querySelector('svg');

                this.elem.innerHTML =elSVG.innerHTML;
                const source = Snap(elSVG);
                const snap = Snap(this.elem);
                let attr;
                attr = source.attr('x');
                if (attr !== null) snap.attr('x', attr);
                attr = source.attr('y');
                if (attr !== null) snap.attr('y', attr);
                attr = source.attr('width');
                if (attr !== null) snap.attr('width', attr);
                attr = source.attr('height');
                if (attr !== null) snap.attr('height', attr);
                attr = source.attr('viewBox');
                if (attr !== null) snap.attr('viewBox', attr);
                attr = source.attr('preserveAspectRatio');
                if (attr !== null) snap.attr('preserveAspectRatio', attr);
                attr = source.attr('data-animation-loop');
                if (attr !== null) snap.attr('data-animation-loop', attr);
                attr = source.attr('data-frames-per-step');
                if (attr !== null) snap.attr('data-frames-per-step', attr);

                dataUtils.setData(this.elem, 'snap', snap);
                dataUtils.setData(this.elem, 'stage', new SVGStage(snap, '.framesAnimation'));
                dataUtils.setData(this.elem, 'animStage', new SVGStage(snap, '.framesAnimationOnStart'));
                dataUtils.setData(this.elem, 'tl', this.generateAnim(snap, dataUtils.getData(this.elem, 'animId')));
                    // dataUtils.setData(this.elem, 'animation', sp);

                this.dispatchComplete(true);
            };

            p1.generateAnim = function (snap, key) {
                let tl = null;
                let s1;
                let s2;
                let l2;
                let l3;
                let i;
                let s3;
                let s4;
                let s5;
                let s6;
                let o1;
                let o2;
                let ease = CustomEase.create('custom', 'M0,0 C0.06,0.164 0.068,0.276 0.098,0.524 0.11,0.69 0.178,1.208 0.234,1.208 0.304,1.208 0.334,0.948 0.42,0.948 0.478,0.948 0.546,1.049 0.616,1.05 0.684,1.05 0.638,1 1,1');

                switch (key)
                {
                    case 'intro-1-0':

                        tl = new TimelineMax({paused: true, repeat: -1});
                        s1 = snap.select('.airplane');
                        tl.set(s1.node, {x: -900});
                        tl.to(s1.node, 10, {x: 1200, ease: Linear.easeInOut});
                        tl.seek(4);
                        tl.pause();
                        break;

                    case 'intro-3-0':

                        tl = new TimelineMax({paused: true, repeat: -1, repeatDelay: 1.5});
                        s1 = snap.select('.satellite');
                        TweenMax.set(s1.node, {x: 1700, y: 60});
                        tl.set(s1.node, {x: 1700, y: 60});
                        tl.to(s1.node, 15, {x: -400, y: -30, ease: Linear.easeInOut});
                        break;

                    case 'intro-5-0':

                        tl = new TimelineMax({paused: true});
                        s1 = snap.select('.heart1');
                        s2 = snap.selectAll('.heart2_part1').items.map(x => x.node);
                        s3 = snap.selectAll('.heart2_part2').items.map(x => x.node);
                        TweenMax.set(s1.node, {xPercent: 15, yPercent: 75, opacity: 0});
                        TweenMax.set(s2, {xPercent: -20, yPercent: 85, opacity: 0});
                        TweenMax.set(s3, {xPercent: -60, yPercent: 85, opacity: 0});

                        tl.set(s1.node, {xPercent: 15, yPercent: 75, opacity: 0});
                        tl.set(s2, {xPercent: -20, yPercent: 85, opacity: 0});
                        tl.set(s3, {xPercent: -60, yPercent: 85, opacity: 0});

                        tl.to(s1.node, 0.5, {opacity: 1, ease: Sine.easeInOut}, "st+="+0.47);
                        tl.to(s1.node, 2.2, {xPercent: 0, yPercent: 0, ease: ease}, "st+="+0.47);

                        tl.to(s2, 0.5, {opacity: 1, ease: Sine.easeInOut}, "st+="+0.45);
                        tl.to(s2, 1.7, {xPercent: 0, yPercent: 0, ease: ease}, "st+="+0.45);

                        tl.to(s3, 0.5, {opacity: 1, ease: Sine.easeInOut}, "st+="+0.45);
                        tl.to(s3, 1.7, {xPercent: 0, yPercent: 0, ease: ease}, "st+="+0.45);
                        break;

                    case 'intro-4-0':

                        tl = new TimelineMax({paused: true});
                        s1 = snap.select('.line');
                        s2 = s1.selectAll('path').items;
                        l2 = [];
                        l3 = [];
                        for (i = 0; i < s2.length; i++)
                        {
                            l2.push(root.svg.getLength(s2[i]));
                            root.svg.eraseStroke(s2[i], l2[i], 1, 0);
                        }
                        s1 = snap.selectAll('.heart').items;
                        s3 = [];
                        for (i = 0; i < s1.length; i++) {
                            s3 = s3.concat(s1[i].selectAll('path').items);
                        }
                        for (i = 0; i < s3.length; i++)
                        {
                            l3.push(root.svg.getLength(s3[i]));
                            root.svg.eraseStroke(s3[i], l3[i], 1, 0);
                        }
                        s4 = snap.selectAll('.note').items.map(x => x.node);
                        TweenMax.set(s4, {opacity: 0});

                        o1 = {
                            lineProgress: 0
                        };
                        o2 = {
                            lineProgress: 0
                        };
                        tl.set(o1, {lineProgress: 0,
                            onUpdate: drawLines,
                            onUpdateParams: [s2, l2, o1, 1, 0]
                        });
                        tl.set(o2, {lineProgress: 0,
                            onUpdate: drawLines,
                            onUpdateParams: [s3, l3, o2, -1, 0]
                        });
                        tl.set(s4, {opacity: 0, yPercent: 100});
                        tl.to(o1, 0.75, {lineProgress: 1, ease: Sine.easeIn,
                            onUpdate: drawLines,
                            onUpdateParams: [s2, l2, o1, 1, 0]
                        }, "st");
                        tl.to(o2, 0.85, {lineProgress: 1, ease: Sine.easeOut,
                            onUpdate: drawLines,
                            onUpdateParams: [s3, l3, o2, -1, 0]
                        }, "st+="+0.75);


                        tl.to(snap.selectAll('.note1').items.map(x => x.node), 0.4*3, {opacity: 1}, "st+="+0.65);
                        tl.to(snap.selectAll('.note2').items.map(x => x.node), 0.35*3, {opacity: 1}, "st+="+0.3);
                        tl.to(snap.selectAll('.note3').items.map(x => x.node), 0.5*3, {opacity: 1}, "st+="+0.44);
                        tl.to(snap.selectAll('.note4').items.map(x => x.node), 0.42*3, {opacity: 1}, "st+="+0.55);
                        tl.to(snap.selectAll('.note5').items.map(x => x.node), 0.36*3, {opacity: 1}, "st+="+0.3);
                        tl.to(snap.selectAll('.note6').items.map(x => x.node), 0.5*3, {opacity: 1}, "st+="+0.72);

                        tl.to(snap.selectAll('.note1').items.map(x => x.node), 0.5*6, {yPercent: 0, ease: ease}, "st+="+0.65);
                        tl.to(snap.selectAll('.note2').items.map(x => x.node), 0.35*6, {yPercent: 0, ease: ease}, "st+="+0.3);
                        tl.to(snap.selectAll('.note3').items.map(x => x.node), 0.7*6, {yPercent: 0, ease: ease}, "st+="+0.44);
                        tl.to(snap.selectAll('.note4').items.map(x => x.node), 0.6*6, {yPercent: 0, ease: ease}, "st+="+0.55);
                        tl.to(snap.selectAll('.note5').items.map(x => x.node), 0.36*6, {yPercent: 0, ease: ease}, "st+="+0.3);
                        tl.to(snap.selectAll('.note6').items.map(x => x.node), 0.78*6, {yPercent: 0, ease: ease}, "st+="+0.72);


                        break;

                    case 'intro-2-0':

                        tl = new TimelineMax({paused: true});
                        s1 = snap.select('.umbrella1');
                        s3 = s1.select('.umbrella1_rotate');
                        s2 = snap.select('.umbrella2');
                        s4 = snap.select('.cloud1');
                        s5 = snap.select('.cloud2');
                        s6 = snap.select('.cloudAndSun');
                        o1 = {
                            rotation: -10
                        };
                        let m = new Snap.Matrix(1,0,0,1,0,0);
                        m.rotate(o1.rotation, 0, 0);
                        s3.transform(m);

                        TweenMax.set(s4.node, {x: 350});
                        TweenMax.set(s5.node, {x: 380});
                        TweenMax.set(s6.node, {x: -300});

                        tl.set(s1.node, {y: 0});
                        tl.set(s2.node, {y: 0});
                        tl.set(s4.node, {x: 350});
                        tl.set(s5.node, {x: 380});
                        tl.set(s6.node, {x: -300});
                        tl.to(s1.node, 3.5, {y: 625, ease: Sine.easeInOut}, 'st');
                        tl.to(s4.node, 0.9, {x: 150, ease: Cubic.easeIn}, 'st');
                        tl.to(s5.node, 0.9, {x: 190, ease: Cubic.easeIn}, 'st');
                        tl.to(s6.node, 0.9, {x: -150, ease: Cubic.easeIn}, 'st');
                        tl.to(s4.node, 1.9, {x: 0, ease: Sine.easeOut}, 'st+='+0.7);
                        tl.to(s5.node, 1.7, {x: 0, ease: Sine.easeOut}, 'st+='+0.7);
                        tl.to(s6.node, 1.8, {x: 0, ease: Sine.easeOut}, 'st+='+0.7);
                        tl.to(s2.node, 3.9, {y: 610, ease: Sine.easeInOut}, 'st+='+0.15);
                        tl.to(o1, 2, {rotation: 0, ease: Sine.easeInOut,
                            onUpdate: function () {
                                let m = new Snap.Matrix(1,0,0,1,0,0);
                                m.rotate(o1.rotation, 0, 0);
                                s3.transform(m);
                            }
                        }, 'st+=' + 3);
                        break;
                }


                function drawLines(lines, lengths, obj, d, o) {

                    let i;
                    if (obj.lineProgress === 0)
                    {
                        for (i = 0; i < lines.length; i++) {
                            root.svg.eraseStroke(lines[i], lengths[i], d, o);
                        }
                        return;
                    }

                    for (i = 0; i < lines.length; i++) {
                        root.svg.drawStroke(lines[i], lengths[i], obj.lineProgress, d, o);
                    }

                }

                return tl;
            }

            createjs.promote(c1, "AsyncCommand");


            // Prepare canvas stage:
            function NewRouteReadyCommand(model, view) {
                this.model = model;
                this.view = view;
            }

            c1 = NewRouteReadyCommand;
            createjs.extend(c1, AbstractCommand);
            p1 = c1.prototype;

            p1.setRouteId = function (id) {
                this._id = id;
            };

            p1.execute = function () {

                // Step 4. Update Route data
                this.model.routeReady(this._id || this.model.getNewRoute());
                this.AbstractCommand_execute.apply(this);
            };

            createjs.promote(c1, "AbstractCommand");




            return new Controller(model, view);
        })(root.coreModel, root.view);



        // Additional view classes:
        // SVG frames animation stage
        function SVGStage(snap, selector) {
            this.snap = snap;
            this._animations = [];
            this.loop = this.snap.attr('data-animation-loop') !== null;
            this.framesPerStep = parseInt(this.snap.attr('data-frames-per-step'));
            if (isNaN(this.framesPerStep))
                this.framesPerStep = 1;

            const elems = this.snap.selectAll(selector).items;
            let elem;
            for (elem of elems)
            {
                this._animations.push(new SVGFramesAnimation(elem, this.loop));
            }
        }

        let p1 = SVGStage.prototype;

        p1.handleEvent = function (event) {
            if (event.type !== 'tick') return;

            if (createjs.Ticker.getTicks(true) % this.framesPerStep > 0) return;

            let anim;
            for (anim of this._animations)
            {
                anim.nextFrame();
            }
        };

        p1.reset = function () {
            let anim;
            for (anim of this._animations)
            {
                anim.reset();
            }
        }


        function SVGFramesAnimation(snap, loop) {
            this.snap = snap;
            this.loop = loop;
            this.frames = snap.children();
            this.currentFrame = 0;

            let i;
            for (i = 0; i < this.frames.length; i++)
            {
                if (this.frames[i].node.nodeType !== 1) {
                    this.frames.splice(i, 1);
                    i--;
                    continue;
                }
                if (i > 0)
                    this._hideNode(this.frames[i].node);
            }
            this.numFrames = this.frames.length;
        }

        p1 = SVGFramesAnimation.prototype;

        p1.nextFrame = function () {
            this._prevFrame = this.currentFrame;
            this.currentFrame++;
            if (this.currentFrame > this.numFrames - 1) {
                if (!this.loop) {
                    this.currentFrame--;
                    return;
                }
                this.currentFrame = 0;
            }
            this._update();
        }

        p1.reset = function () {
            this._prevFrame = this.currentFrame !== 0 ? this.currentFrame : undefined;
            this.currentFrame = 0;
            this._update();
        }

        p1._update = function () {
            if (typeof this._prevFrame !== "undefined")
            {
                this._hideNode(this.frames[this._prevFrame].node);
                this._prevFrame = undefined;
            }
            this._showNode(this.frames[this.currentFrame].node);
        }


        p1._showNode = function (node) {
            if (!node) return;
            node.style.display = "block";
        }

        p1._hideNode = function (node) {
            if (!node) return;
            node.style.display = "none";
        }



    // 2. Prepare Main Route:
    // 2.1. Load Main Route media
    // 2.2. Prepare Main view

    // ROUTE
    // 3. Prepare Current Route if necessary:
    // 3.1. Load html

    // 3.2. Load media
    // 3.3. Prepare view
    // 4. Update Route data
    // 5. Display current Route and hide preloader


    // PRELOADER
    root.preloaderAnimStage = null;
    root.preparePreloader = () => {
        const snap = Snap(document.querySelector('.preloader svg'));
        root.preloaderAnimStage = new SVGStage(snap, '.framesAnimation');
    };

    root.preloaderStartAnim = () => {
        if (root.preloaderAnimStage)
            createjs.Ticker.addEventListener('tick', root.preloaderAnimStage);
    }

    root.preloadingStarted = () => {
        root.preloaderStartAnim();

        root.domStateStore.setState('loaderEnabled', 'enabled', true);
        setTimeout(() => {
            root.domStateStore.setState('loading', 'load', true);
        }, 300);
    };

    root.preloadingComplete = () => {
        if (root.preloaderAnimStage)
            createjs.Ticker.removeEventListener('tick', root.preloaderAnimStage);

        root.domStateStore.setState('loading', 'loaded', true);
        setTimeout(() => {
            root.domStateStore.setState('loaderEnabled', 'disabled', true);
        }, 470);
    };

    // Size utils
    root.winOffsetWidth = () => {
        let w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0];
        return w.innerWidth || e.clientWidth || g.clientWidth;
    };

    root.winOffsetHeight = () => {
        let w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0];
        return w.innerHeight || e.clientHeight || g.clientHeight;
    };

    root.docHeight = () => {
        let g = document.body,
            e = document.documentElement;
        return typeof document.height !== 'undefined' ? document.height : Math.max( g.scrollHeight, g.offsetHeight,e.clientHeight, e.scrollHeight, e.offsetHeight );
    };

    root.getWinScrollTop = () => {
        let w = window,
            d = document,
            g = d.getElementsByTagName('body')[0];
        return w.pageYOffset !== undefined ? w.pageYOffset : (d.documentElement || g.parentNode || g).scrollTop;
    };

    root.preparePreloader();
    root.preloaderStartAnim();
    root.controller.init();


})(window.appCore = window.appCore || {});





// WEBPACK FOOTER //
// ./js/main.js